import { render, staticRenderFns } from "./townShip.vue?vue&type=template&id=40283424&scoped=true&"
import script from "./townShip.vue?vue&type=script&lang=js&"
export * from "./townShip.vue?vue&type=script&lang=js&"
import style0 from "./townShip.vue?vue&type=style&index=0&id=40283424&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40283424",
  null
  
)

export default component.exports